module.exports = __webpack_public_path__ + "static/media/icon_112.522ac36d.svg";